import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9003;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  z-index: 9004;
`;

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  color: #303030;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  color: #696969;
  padding: 0;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 24px;
  margin-top: 24px;
`;

export const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InfoLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #303030;
`;

export const InfoValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #303030;
`;

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #ebebeb;
  margin: 16px 0 0;
`;

export const SectionTitle = styled.div`
  margin-top: 20px;
  margin-bottom: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #303030;
`;

export const TableHeader = styled.div<{ $hideCommission?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hideCommission }) =>
    $hideCommission ? '1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr 1fr'};
  padding: 10px 12px;
  font-size: 12px;
  color: #696969;
  font-weight: 400;
  background-color: #f5f5f5;
  border-radius: 4px 4px 0 0;
`;

export const TableBody = styled.div`
  max-height: 200px;
  overflow-y: auto;
`;

export const TableRow = styled.div<{ $even?: boolean; $hideCommission?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $hideCommission }) =>
    $hideCommission ? '1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr 1fr'};
  padding: 12px;
  align-items: center;
  background-color: ${({ $even }) => ($even ? '#f5f5f5' : '#fff')};
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
  color: #303030;
`;

export const ActionsDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 8px;
`;

export const OutlineButton = styled.button`
  height: 40px;
  padding: 0 20px;
  border-radius: 20px;
  border: 1px solid #0090d3;
  background-color: #fff;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  height: 40px;
  padding: 0 20px;
  border-radius: 20px;
  border: none;
  background-color: #0090d3;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const TextButton = styled.button`
  margin-right: auto;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #0090d3;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 8px 0;
`;

export const LoadingMessage = styled.p`
  margin: 24px 0 0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #696969;
`;

export const ErrorMessage = styled.p`
  margin: 24px 0 0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #c53030;
`;
